const DAY = 86_400_000;

/**
 * "Last active"/"invited" wording as an i18n key plus count: never, today, N days, N weeks.
 * @param {string|null} iso
 * @param {number} [now]
 */
export const getRelativeDays = (iso, now = Date.now()) => {
  if (!iso) return { key: 'memberDetail.values.never' };
  const days = Math.floor((now - new Date(iso).getTime()) / DAY);
  if (days < 1) return { key: 'memberDetail.values.today' };
  if (days < 14) return { key: 'memberDetail.relative.daysAgo', count: days };
  return { key: 'memberDetail.relative.weeksAgo', count: Math.floor(days / 7) };
};

/** Whole days left until `iso` (rounded up, 0 when past or missing). */
export const daysUntil = (iso, now = Date.now()) => {
  if (!iso) return 0;
  return Math.max(0, Math.ceil((new Date(iso).getTime() - now) / DAY));
};
